import { Box, Grid } from '@mui/material'
import React from 'react'
import PerfectScrollbar from "react-perfect-scrollbar"
import AppCard from './AppCard';
import { FetchAllApps } from 'api/apps';
import Cookies from 'js-cookie';

// export const cardData = (resource_available) => [
//     {
//         id: 'fundability-assessment',
//         title: resource_available ? 'Fundability Report' : "Check Fundability",
//         badge: 'Plus',
//         description: 'A powerful tool that deeply analyzes your startup\'s strategy, team, market traction, and business model giving you a clear, data-backed fundability score that shows exactly how investor-ready you are, where the gaps lie, and how to raise capital faster with confidence.',
//         image: '',
//         buttonText: resource_available ? "View" : 'Get Started',
//         buttonVariant: 'contained',
//         onClick: () => {
//             if (resource_available) {
//                 window.open("http://localhost:3000/startup/check-fundability/report/68cdcbf1db35a7370a58c216");
//             }
//             else {
//                 window.open("http://localhost:3000/startup/check-fundability/generating-assessment");
//             }

//         }
//     },
//     {
//         id: 'pitch-deck-analyzer',
//         title: 'Pitch Deck Analyzer',
//         badge: 'Plus',
//         description: 'Pitch Deck Analyzer helps you test your deck through an investor\'s lens, highlight gaps, and improve it so you pitch with clarity, confidence, and higher chances of funding.',
//         image: '',
//         buttonText: 'Coming Soon',
//         buttonVariant: 'outlined',
//         isComingSoon: true,
//         onClick: () => {

//         }
//     },
// ];

const Apps = ({inProfileView = false}) => {

    const cookieStartupId = Cookies.get("X-ST-ID");
    const { data: apps, isLoading } = FetchAllApps(cookieStartupId);
    return (
        <PerfectScrollbar
            // containerRef={containerRef}
            style={{ height: inProfileView ? "calc(-12rem + 100dvh)" : "calc(-10rem + 100dvh)" }}>
            {/* {!isNotLargeScreen && <Box sx={{ paddingInline: "2rem" }}>
                      <img loading='lazy' src={fundingRoundsBackground} style={{ width: '100%', maxHeight: '232.3px', height: '100%' }} />
                    </Box>} */}
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(min(22.4375rem, 100%), 1fr))',
                gap: { xs: "2rem", sm: "3rem", md: "4rem" },
                padding: { xs: "0 1rem 1rem 1rem", md: "0 1rem 2rem 2rem" },
                justifyItems: { xs: 'center', md: "start" }
            }}>
                {/* {cardData(resource_available).map((card) => (
                    <AppCard
                        key={card.id}
                        card={card}
                        onClick={card.onClick}
                    />
                ))} */}
                {isLoading ? <></> : apps?.map((app, index) => {
                    return <AppCard
                        key={index}
                        card={app}
                        onClick={() => {
                            app?.link && window.open(app?.link)
                        }}
                        cardSx={app?.cardStyle}
                    />
                })}
            </Box>

        </PerfectScrollbar>
    )
}

export default Apps